











import { Component, Vue } from 'vue-property-decorator';
import { SortMetadata } from '../Scripts/SortMetadata';
import { FilterHelper } from '../Scripts/FilterHelper';

@Component
export default class SortParameters extends Vue {
	get sortOptions (): SortMetadata[] {
		return SortMetadata.list();
	}

	get selected (): SortMetadata {
		return this.sortOptions.find((o) => o.key === this.$store.state.sort) || this.sortOptions[0];
	}

	public sort (option: SortMetadata): void {
		const helper = new FilterHelper(this.$router);
		helper.setSort(option.key);
	}
}
